import React, { useEffect, useState } from "react";
import UserWidgets from "Components/Users/UserWidgets";
import UsersTable from "Components/Users/UsersTable";
import { getAllUser } from "Common Usage/apiService";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [userDataLoading, setUserDataLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState("All Users");
  const [counts, setCounts] = useState({
    totalUsers: 0,
    activeUsers: 0,
    blockedUsers: 0,
  });

  const fetchUsers = async (page = 1, search = "", filter = "All Users") => {
    try {
      setUserDataLoading(true);
      const data = await getAllUser(page, search, filter);
      setUsers(data?.data || []);
      setTotalPages(data?.totalPages || 1);
      setCounts(data?.counts || {});
    } catch (error) {
      console.log("getAllUser-Error", error.message);
    } finally {
      setUserDataLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage, searchTerm, selectedOption);
  }, [currentPage, searchTerm, selectedOption]);

  return (
    <React.Fragment>
      <UserWidgets counts={counts} getActiveUsers={counts.activeUsers} getBlockedUsers={counts.blockedUsers} totalUsers={counts.totalUsers}/>
      <UsersTable
        users={users}
        userDataLoading={userDataLoading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
    </React.Fragment>
  );
};

export default Users;
